export function tokenHash(string: string): Record<string, boolean> {
  return string.trim().split(/\s+/).reduce((hash, token)=>{
    hash[token] = true;
    return hash;
  }, {})
}

export function domId(prefix = "id") {
  return `${prefix}-${Math.random().toString(36).substring(2, 15)}`;
}

export function escapeAttribute(str) {
  return str.replace(/[&<>"']/g, char => {
    switch (char) {
      case '&': return '&#38;';
      case '<': return '&#60;';
      case '>': return '&#62;';
      case '"': return '&#34;';
      case "'": return '&#39;';
    }
  });
}

/**
 * Svelte attachment that scrolls an element into view when it mounts.
 * Usage: <div {@attach scrollIntoView({ behavior: 'smooth' })}>
 */
export function scrollIntoView(options?: ScrollIntoViewOptions) {
  return (element: Element) => {
    element.scrollIntoView(options);
  };
}
